import {
  NOTIFICATION_EVENT,
  STATUS_CHANGED_EVENT,
  WEBSOCKET_CONNECTED_EVENT,
  WEBSOCKET_FAILED_EVENT,
} from "constants/events";
import { Severity } from "constants/Severity";
import {
  WAREHOUSE_FIELD_FILTER,
  WEB_SOCKET_URL,
} from "constants/webhooksConstants";
import { useAppSelector } from "hooks/StoreHooks";
import { transformNotificationResponseToResource } from "models/Responses/NotificationResponse";
import { transformStatusResponseElementToResource } from "models/Responses/StatusResponse";
import { ReactNode, useEffect, useMemo, useState } from "react";
import { usePostNotificationReadMutation } from "services/api/warehouseApi";
import StompComponent, {
  StompFilter,
} from "services/webSockets/StompComponent";
import { SubscriptionInfos } from "services/webSockets/SubscriptionSocket";
import { selectToken } from "store/Selectors/appStateSelector";
import { getUsername } from "utils/getUsername";
import { EntrepotChangedEvent, NotificationEvent, NotificationMarkAsReadEvent, NotificationReceivedEvent, StatusChangedReceivedEvent, WebsocketConnectedEvent, WebsocketFailedEvent } from "./Event";

type Props = {
  state?: string;
  children: ReactNode;
};

const ApplicatWS = () => {
  const SUBBED_EVENTS_LIST = [STATUS_CHANGED_EVENT, NOTIFICATION_EVENT];
  const [currentLocationStoreNb, setCurrentLocationStoreNb] =
    useState<number>(0);
  const authToken = useAppSelector(selectToken);
  const user = getUsername();

  const [ sendNotificationRead ] = usePostNotificationReadMutation();  

  function markAsRead(
    notificationId: string,
    user: string | null,
    authToken: string,
    storeNb: number,
  ) {
    console.log("mark as read", notificationId);
   
    try {
      const date = new Date().toISOString();
      const notificationReadJSON =  { luLe: date, luPar: user };

      sendNotificationRead({
        storeNb: storeNb,
        notificationId: notificationId,
        action: JSON.stringify(notificationReadJSON),
        token: authToken,
      });
    } catch (err) {
      console.error("Erreur lors de la lecture des notifications", err);
    }
  }

  useEffect(() => {
    NotificationMarkAsReadEvent.subscribe((e) => {
      console.log("Notif lue...", e);
      markAsRead(e, user, authToken,currentLocationStoreNb);
    });
    EntrepotChangedEvent.subscribe((e) => {
      console.log("Changement d'entrepôt, WS refait", e);
      setCurrentLocationStoreNb(e);
    });
  }, []);

  const warehouseWebSocketFilter = useMemo(() => {
    if (currentLocationStoreNb == undefined) return;
    else {
      return {
        field: WAREHOUSE_FIELD_FILTER,
        operator: "==",
        value: currentLocationStoreNb ? currentLocationStoreNb.toString() : "0",
      } as StompFilter;
    }
  }, [currentLocationStoreNb]);

  const subbedEventsAndFilters = useMemo<SubscriptionInfos[]>(
    () => [
      ...SUBBED_EVENTS_LIST.map((event: any) => ({
        subbedEvent: event,
        filters: warehouseWebSocketFilter ? [warehouseWebSocketFilter] : [],
      })),
    ],
    [warehouseWebSocketFilter, currentLocationStoreNb],
  );

  function handleApplicatEvent(eventMsg: any) {
    console.log("Receving event", JSON.stringify(eventMsg));
    if (eventMsg.event?.type === NOTIFICATION_EVENT) {
      const notificationResource = transformNotificationResponseToResource(
        eventMsg.data,
      );
      NotificationReceivedEvent.publish(notificationResource);
    }
    if (eventMsg.event?.type === STATUS_CHANGED_EVENT) {
      const statusData = transformStatusResponseElementToResource(
        eventMsg.data,
      );
      StatusChangedReceivedEvent.publish(statusData);
    }

    if (eventMsg.event?.type === WEBSOCKET_CONNECTED_EVENT) {
      WebsocketConnectedEvent.publish("Connecté.");
      NotificationEvent.publish({
        text: "Connecté à Applicat!",
        severity: Severity.SUCCESS,
        duration: 2000,
      });
    }
    if (eventMsg.event?.type === WEBSOCKET_FAILED_EVENT) {
      WebsocketFailedEvent.publish("Échec.");
      NotificationEvent.publish({
        text: "Connexion à Applicat perdue !",
        severity: Severity.ERROR,
      });
    }
  }

  return (
    <StompComponent
      key={"sc-" + currentLocationStoreNb}
      webSocketUrl={WEB_SOCKET_URL}
      authToken={authToken}
      subscriptions={subbedEventsAndFilters}
      handleApplicatEvent={handleApplicatEvent}
    >
      <></>
      <></>
    </StompComponent>
  );
};

export default ApplicatWS;
